import Vue from 'vue'
import Vuex from 'vuex'
import TravellersStore from './Travellers/index.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  modules: {
    TravellersStore
  }
})
